import { ActionTree } from "vuex";
import { ISecurityState } from "./state";
import { AxiosResponse } from "axios";
import { ITransporter, IAskAppointment, IAppointmentSlot, IAppointmentSecurityDay } from "@/models";
import { apiClient } from "@/services";
import { ADD_SECURITY_DAY } from "./mutations-types";

export const actions: ActionTree<ISecurityState, number> = {

    async fetchSecurityDays(context, data: any): Promise<AxiosResponse<IAppointmentSecurityDay>> {
        const response = await apiClient.get<IAppointmentSecurityDay>(`/securities/appointments?day=${data}`);
        context.commit(ADD_SECURITY_DAY, response.data);

        return response;
    },

    async addAskAppointment(context, data: IAskAppointment): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/securities/appointments`, data);

        return response;
    },

    async updateAppointmentState(context, data: any): Promise<AxiosResponse<void>> {
        const response = await apiClient.post<void>(`/securities/appointments/${data.appointmentId}/state`, data);
        return response;
    },
};
